import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { ehRotaAndonTv } from '../utils/andon';
import versionInfo from '../config/version.json';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation('common');
  const { usuario } = useAuth();
  const year = new Date().getFullYear();
  const { pathname } = useLocation();
  const showVersion = ['admin', 'exxer'].includes(usuario?.tipo_usuario);

  // Andon modo TV: quiosque em tela cheia, sem rodapé.
  if (ehRotaAndonTv(pathname)) return null;

  // Login e cadastro usavam uma barra roxa propria (footer--legacy). Agora todas
  // as telas de acesso usam o rodape normal, que acompanha o tema claro/escuro.
  return (
    <footer className="footer">
      {showVersion && <span className="footer-version">v{versionInfo.version}</span>}
      <p>{t('footerCopyright', { year })}</p>
    </footer>
  );
};

export default Footer;
